import { React, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import styles from './sidebar.module.css'

import constants from '../../../constants.js'
import utils from '../../../utils/utils.js'
import { useSidebarProvider } from '../../../providers/SidebarProvider.js';
import { useLeagueTypeProvider } from '../../../providers/LeagueTypeProvider.js';

import Select from '../../common/Select/Select.js'


{/* DECLARATIONS*/}

{/* COMPONENTS */}
const Menu = ({selectedMenuItem, setSelectedMenuItem}) => {
  
  const navigate = useNavigate();
  const { toggleSidebar } = useSidebarProvider();
  const { leagueType } = useLeagueTypeProvider();

  const onMenuItemClick = (e) => {
    //TODO: Don't push to history. Shouldn't have to click back a bunch.
    var url = "";
    if (e.target.innerText.toLowerCase() !== constants.sidebarItems[0]) {
      url = e.target.innerText.toLowerCase();
    }

    // If we are on mobile, hide the sidebar after selecting an option
    if (window.innerWidth <= 1300){
      toggleSidebar();
    }

    setSelectedMenuItem(e.target.innerText.toLowerCase());
    navigate("/" + leagueType + "/" + url, { replace: true });
  }

  return (
    <div className={styles.Menu}>
      {constants.sidebarItems.map(item => {
          //className={item == selectedMenuItem ? styles.MenuItemSelected : styles.MenuItem}
          return(
            <div key={item} className={`${styles.MenuItem} ${item==selectedMenuItem ? styles.MenuItemSelected : ""}`} onClick={onMenuItemClick}>
              <img 
                className={styles.MenuIcon}
                src={"/icons/" + item +  (item == selectedMenuItem ? constants.icons.cplYellow : constants.icons.cplBlue)}/>
              <span 
                className={styles.MenuIcon} 
                style={{color: constants.secondary}}>
                  {utils.capitalize(item)}
              </span>
            </div>
          )
        })
      }
    </div>)
}

const LeagueType = ({}) => {
  const navigate = useNavigate();
  const { leagueType } = useLeagueTypeProvider();

  const options = [
    {value: constants.pages.leagues, label: constants.labels.mixedLeagues},
    {value: constants.pages.genderLeagues, label: constants.labels.genderLeagues},
    {value: constants.pages.localLeagues, label: constants.labels.localLeagues},
  ]

  const handleChange = (e) => {
    navigate("/" + e.currentTarget.value, { replace: true });
  }

  return (
    <div className={styles.Location}>
      <div className={styles.SidebarLabel}>
        {constants.labels.leagueType}
        <br/>
      </div>
      <Select
        onChange={handleChange}
        additionalStyle={styles.LeagueTypeSelect}
        currentValue={leagueType}
        options={options}/>

    </div>
  )
}

const Location = ({locations, selectedLocation, setSelectedLocation, setSelectedDivision}) => {
  const navigate = useNavigate();
  const { leagueType } = useLeagueTypeProvider();
  const path = useLocation();

  const options = locations.map(location => {
    return {value: location[constants.locationId], label: location[constants.locationName]}
  })

  const handleChange = (e) => {
    // Returns a HTMLOptionsCollection of the select options with a 'selectedIndex' field.
    // This is essentially the newly selected option
    const option = e.target.options[e.target.options.selectedIndex];
    const currentLocation = locations.find(item => item[constants.locationId] == option.value);

    const divisions = utils.sortDivisions(currentLocation[constants.divisions]);

    const newLocation = {};
    newLocation[constants.locationId] = option.value;
    newLocation[constants.locationName] = option.label;

    
    // Whenever the location changes, we should default to the first division. Is there a better practice for this? Probably.
    const newDivision = {};
    newDivision[constants.divisionId] = divisions[0][constants.divisionId];
    newDivision[constants.divisionName] = divisions[0][constants.divisionName];

    setSelectedLocation(newLocation);
    
    setSelectedDivision(newDivision);

    // If the user is in any of the matchup pages and the location/division change, 
    // we should kick them back to the lineups for that week.
    if (path.pathname.endsWith("/matchup")){
      navigate("/" + leagueType + "/" + constants.sidebarItems[1], { replace: true });
    }
  }

  return (
    <div className={styles.Location}>
      <div className={styles.SidebarLabel}>
        {leagueType == constants.pages.localLeagues ? constants.labels.club : constants.labels.regions}
        <br/>
      </div>
      <Select
        onChange={handleChange}
        additionalStyle={styles.LocationSelect}
        currentValue={selectedLocation[constants.locationId]}
        options={options}/>

    </div>
  )
}

const Divisions = ({divisions, selectedDivision, setSelectedDivision}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { leagueType } = useLeagueTypeProvider();

  const onDivisionChange = (e) => {
    if (e.target.id != selectedDivision[constants.divisionId]){
      const newDivision = {};
      newDivision[constants.divisionId] = e.target.id;
      newDivision[constants.divisionName] = e.target.innerText;

      setSelectedDivision(newDivision);

      // If the user is in any of the matchup pages and the location/division change, 
      // we should kick them back to the lineups for that week.
      if (location.pathname.endsWith("/matchup")){
        navigate("/" + leagueType + "/" + constants.sidebarItems[1], { replace: true });
      }
    }
  }

  return (
    <div className={styles.DivisionGroup}>
      <div className={styles.SidebarLabel}>{constants.labels.division}</div>
      {divisions.map(division => {
        return (
          <div
            id={division[constants.divisionId]}
            key={division[constants.divisionId]}
            className={`${styles.DivisionButton} ${division[constants.divisionId] == selectedDivision[constants.divisionId] ? styles.DivisionButtonSelected : ""}`}
            onClick={onDivisionChange}>
              {division[constants.divisionName]}
          </div>
        )
        })}
    </div>
  )
}

const Season = ({seasonList, selectedSeason, setSelectedSeason}) => {
  const options = seasonList.map(season => {
    return {
      value: season[constants.api.seasonNumber] + "-" + season[constants.api.seasonYear],
      label: constants.seasonLabel[season[constants.api.seasonNumber]] + " " + season[constants.api.seasonYear],
      key: season[constants.api.seasonId]}
    }
  )

  const handleChange = (e) => {
    setSelectedSeason(e.currentTarget.value);
  }

  return (
    <div className={styles.Season}>
      <div className={styles.SidebarLabel}>
        {constants.labels.seasons}
        <br/>
      </div>
      <Select
        onChange={handleChange}
        additionalStyle={styles.SeasonSelect}
        currentValue={selectedSeason}
        options={options}/>

    </div>
  )
}

{/* MAIN */}
const Sidebar = ({seasonList, locationList, selectedSeason, setSelectedSeason, selectedLocation, setSelectedLocation, selectedDivision, setSelectedDivision, selectedMenuItem, setSelectedMenuItem}) => {

  const currentLocation = locationList.find(location => location[constants.locationId] == selectedLocation[constants.locationId]);
  const divisionList = utils.sortDivisions(currentLocation[constants.divisions]);

  return (
    <div className={styles.Sidebar}>

      <Menu selectedMenuItem={selectedMenuItem} setSelectedMenuItem={setSelectedMenuItem}/>

      <hr className={styles.Separator}/>

      <LeagueType/>

      <hr className={styles.Separator}/>

      <Location locations={locationList} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation} setSelectedDivision={setSelectedDivision}/>

      <hr className={styles.Separator}/>

      <Divisions divisions={divisionList} selectedDivision={selectedDivision} setSelectedDivision={setSelectedDivision}/>

      <hr className={styles.Separator} style={{marginTop: '0'}}/>

      <Season seasonList={seasonList} selectedSeason={selectedSeason} setSelectedSeason={setSelectedSeason}/>
      <div style={{height: '2em', flexShrink:'0'}}></div>
    </div>
    
  );
}

export default Sidebar;